/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ModeloBodegasTiposPropiedades from 'Infotrack@Modelos/smartStock/bodegasTiposPropiedades';
import IBodegasTiposPropiedades from 'Infotrack@Modelos/smartStock/bodegasTiposPropiedades/entidades/bodegasTiposPropiedades';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';

export default class ControladorModeloBodegasTiposPropiedades {
    private modeloBodegasTiposPropiedades: ModeloBodegasTiposPropiedades;
    constructor() {
        this.modeloBodegasTiposPropiedades = new ModeloBodegasTiposPropiedades();
    }

    public consultarBodegasTiposPropiedades() {
        return this.modeloBodegasTiposPropiedades
            .consultarBodegasTiposPropiedades()
            .then(({ data: { Entidades } }) => Entidades);
    }

    public async crearBodegasTiposPropiedades(bodegasTiposPropiedades: IBodegasTiposPropiedades) {
        await this.modeloBodegasTiposPropiedades.crearBodegasTiposPropiedades(bodegasTiposPropiedades);
    }

    public async editarBodegasTiposPropiedades(bodegasTiposPropiedades: IBodegasTiposPropiedades) {
        await this.modeloBodegasTiposPropiedades.editarBodegasTiposPropiedades(bodegasTiposPropiedades);
    }
    public async eliminarBodegasTiposPropiedades(bodegasTiposPropiedades: IBodegasTiposPropiedades) {
        await this.modeloBodegasTiposPropiedades.eliminarBodegasTiposPropiedades(bodegasTiposPropiedades);
    }

    public validarEntidad(bodegasTiposPropiedades: IBodegasTiposPropiedades): boolean {
        if (bodegasTiposPropiedades.BodegaTipoPropiedadDescripcion === '' || bodegasTiposPropiedades.Propiedad === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarFiltroBodegasTiposPropiedades(bodegasTiposPropiedades: Partial<IBodegasTiposPropiedades>) {
        return this.modeloBodegasTiposPropiedades
            .consultarFiltroBodegasTiposPropiedades(bodegasTiposPropiedades)
            .then(({ data: { Entidades } }) => Entidades);
    }
}
